import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { performanceService } from 'common/utilities/PerformanceService';
import { IPerformanceTimingData } from 'common/utilities/PerformanceService.types';

import { getInitialPerformanceState } from './performanceState';

const initialState: IPerformanceTimingData = getInitialPerformanceState();

export const performanceSlice = createSlice({
  name: 'performance',
  initialState,
  reducers: {
    markTTI: (_, action: PayloadAction<IPerformanceTimingData>) => {
      performance.mark('TTI');
      return { ...action.payload, isPageLoadComplete: true };
    },
    restartPageLoad: (state) => {
      performanceService.resetPageLoadState();
      state.isPageLoadComplete = false;
    },
  },
});

export const { markTTI, restartPageLoad } = performanceSlice.actions;

export default performanceSlice.reducer;
